import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Page title
document.title = 'Inteligencia Social Estratégica';
// OG / Social meta tags
const setMeta = (property: string, content: string) => {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const setMetaName = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
const TITLE = 'Inteligencia Social Estratégica';
const DESC = 'El sistema para detectar engaños, dominar conversaciones y ganar respeto instantáneo.';
const IMG = 'https://cdn.magicpatterns.com/uploads/jq4oCouCmrcu5LgrGg5Vut/ChatGPT_Image_23_feb_2026,_13_39_58.png';
setMeta('og:title', TITLE);
setMeta('og:description', DESC);
setMeta('og:image', IMG);
setMeta('og:type', 'website');
setMetaName('twitter:title', TITLE);
setMetaName('twitter:description', DESC);
setMetaName('twitter:card', 'summary_large_image');
setMetaName('twitter:image', IMG);
render(<App data-id="element-328" />, document.getElementById('root'));